import { login as loginApi, logout as logoutApi, getUserInfo as getUserInfoApi, checkLogin } from '@/api/certification'

const state = {
  token: localStorage.getItem('token') || '',
  tokenName: localStorage.getItem('tokenName') || 'satoken',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  isLoggedIn: !!localStorage.getItem('token')
}

const mutations = {
  SET_TOKEN: (state, { token, tokenName }) => {
    state.token = token
    state.tokenName = tokenName || 'satoken'
    state.isLoggedIn = !!token
    localStorage.setItem('token', token)
    localStorage.setItem('tokenName', tokenName || 'satoken')
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  CLEAR_USER_DATA: (state) => {
    state.token = ''
    state.tokenName = 'satoken'
    state.userInfo = {}
    state.isLoggedIn = false
    localStorage.removeItem('token')
    localStorage.removeItem('tokenName')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // 用户登录
  async login({ commit, dispatch }, loginForm) {
    try {
      const { certificationId, password } = loginForm
      const response = await loginApi(certificationId, password)
      
      // 后端返回格式: { code: 200, msg: "登录成功", data: { token, tokenName, uuid, certificationId, ... } }
      const { token, tokenName } = response.data
      
      // 保存token
      commit('SET_TOKEN', { token, tokenName })
      
      // 登录成功后立即获取完整的用户信息
      try {
        await dispatch('getUserInfo')
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 即使获取用户信息失败，也不影响登录流程
      }
      
      return response
    } catch (error) {
      commit('CLEAR_USER_DATA')
      throw error
    }
  },

  // 获取用户信息
  async getUserInfo({ commit, state }) {
    try {
      if (!state.token) {
        throw new Error('未登录')
      }
      
      const response = await getUserInfoApi()
      // 后端返回格式: { code: 200, msg: "获取成功", data: { userInfo, agentInfo, marketTarget, ... } }
      // 保存完整的业务数据
      commit('SET_USER_INFO', response.data)
      return response
    } catch (error) {
      commit('CLEAR_USER_DATA')
      throw error
    }
  },

  // 用户登出
  async logout({ commit }) {
    try {
      await logoutApi()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      commit('CLEAR_USER_DATA')
    }
  },

  // 检查登录状态
  async checkLogin({ commit, state }) {
    try {
      if (!state.token) {
        return false
      }
      
      const response = await checkLogin()
      return response.data?.isLogin || false
    } catch (error) {
      console.error('Check login error:', error)
      commit('CLEAR_USER_DATA')
      return false
    }
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userInfo: state => state.userInfo,
  token: state => state.token,
  // 业务数据的 getters
  basicUserInfo: state => state.userInfo.userInfo || {},
  agentInfo: state => state.userInfo.agentInfo || {},
  marketTarget: state => state.userInfo.marketTarget || {},
  incentive: state => state.userInfo.incentive || {},
  brandActivity: state => state.userInfo.brandActivity || {},
  channelContract: state => state.userInfo.channelContract || {},
  channelService: state => state.userInfo.channelService || {},
  orderData: state => state.userInfo.orderData || {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
